export default __webpack_public_path__ + "static/media/data-center.7729ff30.jpg";